import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface CampaignSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (type: "OL" | "ZNS") => void;
}

const CampaignSelectionDialog: React.FC<CampaignSelectionDialogProps> = ({
  open,
  onClose,
  onSelect,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography variant="h6" component="div">
            Campaign Selection
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Select which type of campaign you want to import recipient list to
          </Typography>
        </Box>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box
            sx={{
              p: 2,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              OL Campaign
            </Typography>
            <Button
              variant="outlined"
              size="small"
              onClick={() => onSelect("OL")}
              sx={{ minWidth: 80 }}
            >
              SELECT
            </Button>
          </Box>
          <Box
            sx={{
              p: 2,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              ZNS Campaign
            </Typography>
            <Button
              variant="outlined"
              size="small"
              onClick={() => onSelect("ZNS")}
              sx={{ minWidth: 80 }}
            >
              SELECT
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CampaignSelectionDialog;
